import axios from "axios";
import {HTTP_RESPONSE} from "../../Utility/Helpers/constants";
import UserProvier from "../../../security/UserProvier";


export const DATA_API_URL = process.env.REACT_APP_API_BASE_URL + 'suppliers';
export const DATA_API_URL_USER_SUP = process.env.REACT_APP_API_BASE_URL + 'user-company-suppliers';
const queries = (itemPerPage = 15, page = 1,fkCieId ,search = '') => {

    return DATA_API_URL + '?filter[where][nom][like]=%'+search+'%' +
        '&filter[where][fkCieId]='+fkCieId+
        '&filter[limit]=' + itemPerPage + '&filter[skip]=' + (((page - 1) * itemPerPage) > 0 ? ((page - 1) * itemPerPage) : 0);
}
const queriesAll = (fkCieId = 1) => {

    return DATA_API_URL + '/getAllSuppliers/'+fkCieId
}
const SupplierRepository = {
    findAll : async (itemPerPage, page, fkCieId, search = '') =>{
        try {
            const response = await axios
                .get(queries(itemPerPage,page,fkCieId, search));
                console.log(response.data);
            return response.data;
        } catch (e) {
            if (e.response) {
                throw e.response;
            } else {
                throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND };
            }
        }

    },
    getAll : async (fkCieId) =>{
        try {
            console.log("on passe ici ?")
            const response = await axios
                .get(queriesAll(fkCieId));
                
            return response.data;
        } catch (e) {
            if (e.response) {
                throw e.response;
            } else {
                throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND };
            }
        }
    },
    delete: async (id) => {
        try {
            const response = await axios
                .delete(DATA_API_URL + '/' + id);
            return response.data;
        } catch (e) {
            if (e.response) {
                throw e.response;
            } else {
                throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND };
            }
        }
    },

    add: async (item) => {
    try {
        const response = await axios
          .post(DATA_API_URL_USER_SUP, item);
        return response.data;
      } catch (e) {
        if (e.response) {
          throw e.response;
        } else {
          throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND };
        }
      }
  },
  uploadAttachment: async (item) => {
    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };
    const formData = new FormData();
    // Update the formData object
    formData.append(
        "suppliers",
        item,
        item.name,
    );
    try {
        const response = await axios
            .post(DATA_API_URL + '/importsuppliers', formData, config);
            console.log(response);
        return response.data;
    } catch (e) {
        if (e.response) {
            throw e.response;
        } else {
            throw { ...e, status: HTTP_RESPONSE.HTTP_NOT_FOUND };
        }
    }
}

  
}
export default SupplierRepository;